import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Header from './components/header';
import Navigation from './components/navigation';
import Footer from './components/footer';
import HomePage from './components/main';

function App() {
  return (
    <Router>
      <div className="container">
        <Header />
        <Navigation />
        
        <Routes>
          <Route path="/" element={<HomeWithScroll />} />
        </Routes>
        
        <Footer />
      </div>
    </Router>
  );
}

//Creates a function based on the current location
const HomeWithScroll = () => {
  const location = useLocation();

  // Uses the location to know where to scroll to
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const scrollTo = params.get('scrollTo');
    if (scrollTo) {
      const element = document.getElementById(scrollTo);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  return <HomePage />;
};

export default App;
